<template>
    <div>
        <card-header title="Conferences (Legacy)" icon="fa-presentation"/>

        <card-toolbar>
<!--            <button @click="$openCard('new-course', {}, card)"><i class="far fa-plus"></i>New Course</button>-->
        </card-toolbar>

        <card-body>
            <card-list>
                <search-list-item/>
                <separator-list-item/>
                <conference-tile-legacy
                    v-for="conf in conferences"
                    :card="card"
                    :conf="conf"
                    @click="$openCard('conference-legacy', {confId: conf.id}, card)"
                    :active="child && child.definition.component === 'conference-legacy' && child.props.confId == conf.id"
                />
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SearchListItem from "@/TIER/components/SearchListItem";
    import SeparatorListItem from "@/TIER/components/SeparatorListItem";
    import CardToolbar from "@/TIER/components/CardToolbar";

    import CourseTile from "@/components/tiles/CourseTile";

    import {client as http} from "@/http_client";
    import ConferenceTileLegacy from "../../../components/tiles/ConferenceTileLegacy";

    export default {
        components: {ConferenceTileLegacy, CourseTile, CardToolbar, SeparatorListItem, CardHeader, CardBody, CardList, SearchListItem},
        props: ['card', 'child'],
        data() {
            return {
                conferences: []
            }
        },
        methods: {
            loadCourses: function (force) {
                this.$emit('loading', true);

                http.get('conferences/legacy/', {force}).then(response => {
                    this.conferences = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                });
            },
            reload: function() {
                this.loadCourses(true);
            }
        },
        mounted: function() {
            this.loadCourses();
        }
    }
</script>
